<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3">
        <v-autocomplete
          name="transferReportFromStore"
          dense
          outlined
          v-model="FromStore"
          :items="stores"
          label="From Shop"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          name="transferReportToStore"
          dense
          outlined
          v-model="ToStore"
          :items="stores"
          label="To Store"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="3">
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              dense
              outlined
              single-line
              v-model="StartDate"
              label="From"
              prepend-icon="mdi-calendar-month"
              v-on="on"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="StartDate"
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <!-- datepicker 2 -->
      <v-col cols="12" xs="12" sm="12" md="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              dense
              outlined
              single-line
              v-model="EndDate"
              label="To"
              prepend-icon="mdi-calendar-month"
              v-on="on"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="EndDate"
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="3">
        <v-autocomplete
          name="transferReportPickedBy"
          dense
          outlined
          v-model="PickedBy"
          :items="users"
          label="Picked By"
          item-text="name"
          item-value="id"
        ></v-autocomplete>
      </v-col>
      <v-col cols="3">
        <v-btn color="accent" @click="getRecords" :loading="loader"
          >Query Data</v-btn
        >
      </v-col>

      <v-col cols="6" xs="6" md="3">
        <v-btn color="accent" text @click="thermalPrint">
          <v-icon>mdi-printer</v-icon> Print Via Thermal
        </v-btn>
      </v-col>

      <v-col cols="6" xs="6" md="3">
        <v-btn color="primary" text to="/stock/transfer/deliveries">
          Stock Transfer Deliveries
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="subtitle-2 text--primary">
        Total Value: {{ totalAmount.toLocaleString() }}
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="search"
          label="Search"
          outlined
          dense
        ></v-text-field>
        <!-- start of table -->
        <v-data-table
          :items-per-page="pageItems"
          :headers="headers"
          :items="stockTransfers"
          :search="search"
        >
          <template v-slot:item.BuyingPrice="{ item }">
            <span>{{ item.BuyingPrice.toLocaleString() }}</span>
          </template>
          <template v-slot:item.LineTotal="{ item }">
            <span>{{
              (item.BuyingPrice * item.Quantity).toLocaleString()
            }}</span>
          </template>
          <template v-slot:item.received="{ item }">
            <span
              style="color: green; font-weight: bold"
              v-if="item.received == 'Y'"
              >Received</span
            >
            <span
              style="color: red; font-weight: bold"
              v-if="item.received == 'N'"
              >Not Received Yet</span
            >
          </template>
        </v-data-table>
        <!-- end -->
      </v-col>
    </v-row>

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import { generatePdf } from "@/common/transferMethods.js";
import { http } from "@/common/index";
export default {
  data() {
    return {
      search: null,
      pageItems: 100,
      menu1: false,
      menu2: false,
      StartDate: null,
      EndDate: null,
      FromStore: null,
      ToStore: null,
      PickedBy: null,
      loader: false,
      stores: [],
      users: [],
      yheaders: [
        { text: "Item Code", value: "product.ItemCode" },
        { text: "Product", value: "product.Name" },
        { text: "Ref No./ IMEI", value: "ref1" },
        { text: "Quantity", value: "Quantity" },
        { text: "From Shop", value: "fromstore.Name" },
        { text: "To Store", value: "tostore.Name" },
        { text: "Picked By", value: "pickedby.name" },
        { text: "Date", value: "DocDate" },
      ],
      headers: [
        { text: "Item Code", value: "product.ItemCode" },
        { text: "Product", value: "product.Name" },
        { text: "Ref No./ IMEI", value: "ref1" },
        { text: "Quantity", value: "Quantity" },
        { text: "Unit", value: "uomentry.UomName" },
        // { text: "Buying Price", value: "BuyingPrice" },
        // { text: "Total", value: "LineTotal" },
        { text: "From Shop", value: "fromstore.Name" },
        { text: "To Store", value: "tostore.Name" },
        { text: "Picked By", value: "pickedby.name" },
        { text: "Status", value: "received" },
        { text: "Date", value: "DocDate" },
      ],
      stockTransfers: [],
    };
  },
  computed: {
    totalSalesValue() {
      let total = 0;
      if (this.totalSales) {
        total = this.totalSales.toLocaleString();
      }
      return total;
    },
    totalAmount() {
      let total = 0;
      if (
        typeof this.stockTransfers != "undefined" &&
        this.stockTransfers.length > 0
      ) {
        return this.stockTransfers
          .map((item) => {
            const amount = item.Quantity * item.BuyingPrice;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
  },
  methods: {
    generatePdf,
    getRecords() {
      const self = this;
      const data = {
        StartDate: self.StartDate,
        EndDate: self.EndDate,
        FromStore: self.FromStore,
        ToStore: self.ToStore,
        PickedBy: self.PickedBy,
      };

      self.loader = true;
      const url = `/stock-transfer-report`;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.stockTransfers = res.ResponseData.AllTransfers;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    thermalPrint() {
      const self = this;
      const storeId = this.ToStore;

      const store = this.stores.find((record) => {
        return record.id === storeId;
      });

      let storeName = "";

      if (store) {
        storeName = store.Name;
      }
      let details = {
        storeName: storeName,
        stock: self.stockTransfers,
        date: self.StartDate,
      };

      self.printLocalInventory(details);
    },
    printLocalInventory(stock) {
      return http.post(
        "http://localhost/stalispos-receipt/src/inventory/StockTransfer.php",
        {
          stock,
        }
      );
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printDoc() {
      if (this.StartDate == null || this.EndDate == null) {
        this.$refs.snackbar.show("Please select both dates", "red");
      } else {
        const self = this;
        const pdfDoc = this.generatePdf(
          self.StartDate,
          self.EndDate,
          self.stockTransfers
        );

        this.$refs.pdfPreview.show(pdfDoc);
      }
    },
  },
  created() {
    Promise.all([this.getRecords(), this.getStores(), this.getUsers()]);
  },
};
</script>

<style lang="scss" scoped>
</style>